export const providerAvailability = (payload) => {
  return {
    type: "providerAvailability",
    payload,
  };
};
